import { useAppNavigate } from "../../../../../hooks/useAppNavigate";
import { SCHOOL_CREATE_PROGRAMME_PATH } from "../../../../../hooks/useNextSession";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import React, { FC } from "react";
import { PrimaryButton } from "../../../../layout/Button/Button";
import { verbalTheme } from "../../../../layout/themes/verbal.theme";
import { HeadlineFigureWidget } from "../HeadlineFigureWidget";

export const CreateProgrammeWidget: FC<{ minHeight?: string }> = ({ minHeight }): JSX.Element => {
    const { push } = useAppNavigate();
    const useStyles = makeStyles(
        createStyles({
            imgPlacment: {
                height: "75%",
                width: "75%",
                margin: "auto",
            },
        }),
    );
    const classes = useStyles();

    return (
        <HeadlineFigureWidget minHeight={minHeight}>
            <div className={classes.imgPlacment}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="75%"
                    width="75%"
                    viewBox="0 0 24 24"
                    fill={verbalTheme.palette.primary.main}
                >
                    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-.6.8L9 8.3V4zm11 16H6V4h1v9l3.6 4.5 3.6-4.5V4h1v16z" />
                </svg>
            </div>
            <PrimaryButton
                onClick={() => push(SCHOOL_CREATE_PROGRAMME_PATH)}
                size="small"
                variant="contained"
                fullWidth
            >
                Create programme
            </PrimaryButton>
        </HeadlineFigureWidget>
    );
};
